export enum LanguageValueEnum {
  NL = "nl",
  EN = "en",
}

export const LanguageTypeEnum: Record<string, LanguageValueEnum> = {
  "nl-NL": LanguageValueEnum.NL,
  "en-US": LanguageValueEnum.EN,
  "en-GB": LanguageValueEnum.EN,
};
